import utils from '@/plugins/TravellerUtils';

const announcements = {
  namespaced: true,
  state: {
    /* text announcement */
    textAnnouncementList:{
      listData:[]
    },
    /* Image announcement */
    imgAnnouncementList:{
      listData:[]
    }
  },
  mutations: {
    setTextAnnouncementData(state, entries) {
      state.textAnnouncementList.listData = entries;
    },
    setImageAnnouncementListData(state, entries) {
      state.imgAnnouncementList.listData = entries;
    },
  },
  actions: {
    getAnnouncementImage(context, identifier ) {
      return new Promise((resolve , reject) => {
        this._vm.$traveller_http.get('/traveller/restui/announcement/getAnnouncementImage', {params: { "id": identifier}})
         .then(function(resp) {
           if(utils.checkResponseObjectWithMemeber(resp, 'base64')) {
             resolve(resp.data.base64);
           } else {
             reject("error in query");
           }
         }), error => { reject(error); }
      })
    },
    getImageAnnouncementList( context ) {
      return new Promise((resolve , reject) => {
       const vm = this;
       this._vm.$traveller_http.get('/traveller/restui/announcement/listImgAnnouncements')
         .then(function(resp) {
           if(utils.checkResponseIsArray(resp)) {
             vm.listData = resp.data;
             context.commit('setImageAnnouncementListData', resp.data );
             resolve(resp.data);
           } else {
             reject("error in query");
             return;
           }
         }), error => {
            reject(error);
          }
      })
    },
    removeAnnouncement( context, annId ) {
      return new Promise((resolve , reject) => {
        this._vm.$traveller_http.get('/traveller/restui/announcement/removeAnnouncement',{params:{"id":annId}} )
          .then ( response => {
            if(utils.checkResponseIsOk(response)) {
              resolve(response);
            } else {
              reject("Error removing announcement");
            }
          }), error => {
            reject(error);
          }
      })
    },
    storeImgAnnouncement( context, annData ) {
      return new Promise((resolve , reject) => {
        this._vm.$traveller_http.post('/traveller/restui/announcement/editImgAnnouncement',annData )
          .then ( response => {
            if(utils.checkResponseIsOk(response)) {
              context.dispatch('getImageAnnouncementList');
              resolve(response);
              return;
            } else {
              reject("error storing image announcement");
              return;
            }
          }), error => {
            reject(error);
          }
        resolve("OK");
      })
    },
    sendAnnouncementImage( context, imgData ) {
      let formData = new FormData();
      formData.append('filedata', imgData);
      formData.append('filename', imgData.name);
      return new Promise((resolve , reject) => {
        this._vm.$traveller_http.post('/traveller/restui/announcement/getUploadFile'
          ,formData
          ,{headers:{'Content-Type': 'multipart/form-data'}})
          .then ( response => {
            if(utils.checkResponseObjectWithMemeber(response, 'message')) {
              resolve(response.data.message);
            } else {
              reject();
            }
          }), error => {
            reject(error);
          }
      })
    },
    getAnnouncementTargets( context, annId ) {
      return new Promise((resolve , reject) => {
        var id = annId;
  
        this._vm.$traveller_http.get('/traveller/restui/announcement/getAnnouncementTargets', {params:{"id":id}})
        .then( resp => {
            if(!utils.checkResponseObjectWithMemeber(resp, 'displayTargets')) {
              reject("error in query");
              return;
            }
            var i;
            var listadata = new Array();
            var entry={};
            // näyttökiinnitykset
            var targets = resp.data.displayTargets;
            for(i = 0; i < targets.length; i++) {
              entry={"id":null,"label":null,type:null};
              entry.id = targets[i].id;
              entry.label = targets[i].label;
              entry.type = "display";
              listadata.push(entry);
            }
            // linjakiinnitykset
            targets = resp.data.lineTargets;
            for(i = 0; i < targets.length; i++) {
              entry={"id":null,"label":null,type:null};
              entry.id = targets[i].id;
              entry.label = targets[i].label;
              entry.type = "line";
              listadata.push(entry);
            }
            // reittikiinnitykset
            targets = resp.data.routeTargets;
            for(i = 0; i < targets.length; i++) {
              entry={"id":null,"label":null,type:null};
              entry.id = targets[i].id;
              entry.label = targets[i].label;
              entry.type = "route";
              listadata.push(entry);
            }
            // pysakkikiinnitykset
            targets = resp.data.pysakkiTargets;
            for(i = 0; i < targets.length; i++) {
              entry={"id":null,"label":null,type:null};
              entry.id = targets[i].id;
              entry.label = targets[i].label;
              entry.type = "pysakki";
              listadata.push(entry);
            }
            //context.commit('setSelectedAnnouncementTargets', listadata);
            resolve(listadata);
        }), error => {
            reject(error);
        }
      } )
    }, 
    getTextAnnouncementList( context ) {
      return new Promise((resolve , reject) => {
       const vm = this;
       this._vm.$traveller_http.get('/traveller/restui/announcement/listTextAnnouncements')
         .then(function(resp) {
           if(utils.checkResponseIsArray(resp)) {
             vm.listData = resp.data;
             context.commit('setTextAnnouncementData', resp.data );
             resolve(resp.data);
             return;
           } else {
             reject("error in query");
             return;
           }
         }), error => {
            reject(error);
          }
      })
    },
    storeTextAnnouncement( context, annData ) {
      return new Promise((resolve , reject) => {
        var config = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }; 
        this._vm.$traveller_http.post('/traveller/restui/announcement/editTextAnnouncement',annData, config )
          .then ( response => {
            if(utils.checkResponseIsOk(response)) {
              context.dispatch('getTextAnnouncementList');
              resolve(response);
            } else {
              reject("error in query");
            }
          }), error => {
            reject(error);
          }
        resolve("OK");
      })
    }
  },
  getters: {
  }
}

export default announcements;
